import { Keuzehulp } from '../keuzehulpen'

const hernia: Keuzehulp = {
  title: 'Hernia',
  basePath: '/hernia',
  documentTitle: 'Hernia',
  routes: [
    {
      path: '',
      routeId: 'P15-001',
      nextRouteId: 'P15-002',
      type: 'intro',
      title: 'Voordat je begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/hernia-rug-afwachten-operatie',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die je nodig hebt om de keuzehulp in te vullen',
        },
        {
          title: '15 minuten',
          description: 'Zo lang zijn de meeste mensen bezig met deze keuzehulp',
        },
        {
          title: 'Zoek een rustige plek',
          description: 'Zodat je goed jouw aandacht erbij kunt houden',
        },
        {
          title: 'Bekijk je antwoorden',
          description:
            'Je antwoorden worden niet bewaard. De keuzehulp onthoudt niet waar je gebleven bent',
        },
      ],
    },
    {
      path: '/stap-1',
      routeIndex: '1',
      routeId: 'P15-002',
      nextRouteId: 'P15-003',
      type: 'chapter',
      title: 'Al lang veel last van beenpijn door een hernia',
      subtitle: 'Stap 1',
      description: `
        <p>Je hebt al weken veel last van beenpijn door een hernia. Eerst vertellen we waar je klachten door komen. En wanneer ze over kunnen gaan.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/hernia-stap-1.jpg`,
        alt: '',
      },
      button: 'Start de keuzehulp',
    },
    {
      path: '/stap-1/waardoor-komen-je-hernia-klachten',
      routeId: 'P15-003',
      nextRouteId: 'P15-004',
      type: 'explanation',
      title: 'Waardoor komen je hernia-klachten?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je beenpijn komt door druk op een zenuw in je rug.</p>

          <p>Tussen 2 wervels in je rug zit een schijfje. Daar zit zachte gel in. De gel kan tussen de wervels uit komen als er een zwakke plek in de zijkant van het schijfje zit. De gel drukt dan op 1 of 2 zenuwen.</p>

          <p>Die zenuwen gaan van je rug naar je been, en soms naar je voet.</p>

          <p>De druk op die zenuwen voel je als pijn in je rug, bil en been. En soms ook in je voet. Je kunt er ook minder gevoel in hebben, of een prikkend gevoel. Je kunt ook minder kracht in je been hebben.</p>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/hernia-stap-1_1.png`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/hoe-lang-kan-beenpijn-door-een-hernia-duren',
      routeId: 'P15-004',
      nextRouteId: 'P15-005',
      type: 'explanation',
      title: 'Hoe lang kan beenpijn door een hernia duren?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Beenpijn door een hernia gaat meestal vanzelf over. Meestal binnen 3 maanden.</p>

          <p>Je lichaam zorgt er dan voor dat de gel uit de schijf tussen je wervels vanzelf teruggaat op zijn plek. De gel drukt dan niet meer op de zenuwen. Daardoor heb je geen beenklachten meer.</p>

          <p>Van de 100 mensen met een hernia zijn de klachten bij 76 mensen na 3 maanden minder.</p>

          <p>Na 3 maanden hebben 24 van de 100 mensen dus nog klachten. Bij 12 van die 24 mensen gaan de klachten daarna ook vanzelf over, binnen een jaar.</p>

          <p>De rugpijn kan wel blijven. Of na een tijd terugkomen. Dit komt niet door zenuwen die klem zitten. Artsen denken dat dit komt doordat je spieren, gewrichten en zenuwen onder in de rug tijdelijk niet goed samenwerken.</p>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/hernia-stap-1_2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2',
      routeIndex: '2',
      routeId: 'P15-005',
      nextRouteId: 'P15-006',
      type: 'chapter',
      title: 'Waaruit kun je kiezen als je lang beenpijn hebt door een hernia?',
      subtitle: 'Stap 2',
      description: `
        <p>Je hebt nu langer dan 6 weken beenpijn door een hernia. Je vraagt je af wat je het beste kunt doen. Er zijn 3 manieren om met je klachten om te gaan de komende tijd.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/hernia-stap-2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/mogelijkheden-om-met-beenpijn-door-een-hernia-om-te-gaan',
      routeId: 'P15-006',
      nextRouteId: 'P15-007',
      type: 'explanation',
      title: '3 mogelijkheden om met beenpijn door een hernia om te gaan',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom:0;">Er zijn 3 mogelijkheden om met beenpijn die lang duurt om te gaan:</p>
          <ul style="margin-top:0;">
            <li>Afwachten tot de klachten vanzelf overgaan. Je blijft zo normaal mogelijk bewegen.</li>
            <li>Afwachten tot de klachten vanzelf overgaan. Je blijft zo normaal mogelijk bewegen. Je krijgt medicijnen of prikken tegen pijn.</li>
            <li>Een hernia-operatie.</li>
          </ul>

          <p>De ene mogelijkheid werkt niet beter dan de andere: bij elke manier zijn er na 1 jaar evenveel mensen die geen beenpijn meer hebben. Dus de kans dat je beenpijn na een jaar over is, is even groot: of je nu kiest voor een operatie of niet. </br>
            De kans dat je hernia ooit weer terugkomt, is ook net zo groot bij afwachten als na een operatie.</p>

          <p>Er zijn wel verschillen tussen afwachten en een operatie. Daar lees je meer over als je verdergaat.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-1',
      routeId: 'P15-007',
      nextRouteId: 'P15-008',
      subtitle: 'Maak een keuze',
      title: 'Waar wil je meer over weten?',
      type: 'uniqueQuestion',
      hideFromOverview: true,
      answers: [
        {
          title: 'Afwachten en normaal blijven bewegen',
          nextRouteId: 'P15-008',
        },
        {
          title: 'Afwachten en normaal blijven bewegen met medicijnen of prikken tegen de pijn',
          nextRouteId: 'P15-010',
        },
        {
          title: 'Een hernia-operatie',
          nextRouteId: 'P15-012',
        },
      ],
    },
    {
      path: '/stap-2/afwachten-en-normaal-blijven-bewegen',
      routeId: 'P15-008',
      nextRouteId: 'P15-009',
      type: 'popupCards',
      title: 'Afwachten en normaal blijven bewegen',
      align: 'left',
      description: `
        <div>
          <p>Je kunt bij een hernia afwachten. Dat betekent dat je wacht tot de hernia vanzelf overgaat.</p>

          <p>Afwachten betekent niet: niks doen. Het is belangrijk om door te gaan met je activiteiten. Ook met je werk als het kan. Bewegen is goed bij een hernia. Ook kun je zelf dingen doen die de pijn minder erg maken.</p>

          <p>Bekijk wat de adviezen zijn bij afwachten en normaal blijven bewegen:</p>
        </div>
      `,
      cards: [
        {
          cardTitle: 'Omgaan met pijn',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_3_1-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Wat je denkt, voelt en doet, heeft invloed op pijn:</p>
              <ul>
                <li>Bedenk dat de pijn niet schadelijk of gevaarlijk is. Er kan niets stukgaan in je rug. Je kunt je hernia ook niet erger maken. Dit kan je geruststellen.</li>
                <li>Zorg dat je bezig bent met andere dingen. Je denkt dan minder aan de pijn. Bijvoorbeeld door leuke dingen doen, mensen ontmoeten, werken, hobby's, muziek en natuur.</li>
                <li>Zoek steun bij bijvoorbeeld familie, vrienden en collega's. Begrip, steun en vertrouwen zorgen dat je de pijn beter aankunt.</li>
                <li>Blijf werken, als dat kan. Geven je klachten problemen op het werk? Bespreek het met je werkgever en de bedrijfsarts. Aanpassingen op het werk kunnen helpen.</li>
                <li>Blijf actief. Maak een plan voor elke dag. Kies wat belangrijk voor je is.</li>
                <li>Zorg voor ontspanning. Ga bijvoorbeeld elke dag even wandelen of doe ontspannings-oefeningen.</li>
                <li>Probeer stress minder te maken. Veel stress kan pijn erger maken.</li>
                <li>Praat erover als je je somber, bang of boos voelt door de pijn. Dat kan ook met je huisarts of praktijkondersteuner.</li>
              </ul>

              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_3_1.jpg alt="" />

            </div>
          `,
        },
        {
          cardTitle: 'Adviezen om beter te slapen',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_3_2-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Als je goed slaapt, kun je de pijn overdag beter aan. Probeer welke slaapadviezen bij jou helpen, zoals:</p>
              <ul>
                <li>Probeer zo te gaan liggen dat je zo weinig mogelijk pijn hebt. Bijvoorbeeld op je rug met een paar kussens onder je knieën. Of op je zij met gebogen knieën. Praat erover met je huisarts als je door de pijn niet kunt slapen.</li>
                <li>Slaap overdag liever niet. Soms is het wel fijn om even een pauze of rustmoment te nemen als je door de pijn slecht hebt geslapen. </br>
                  Als je wilt, kun je ook even gaan liggen. Doe dit maximaal een half uur. En voordat het 3 uur 's middags is. En doe dit niet in je bed, maar bijvoorbeeld op de bank. Als je het langer doet of later op de dag, dan slaap je 's nachts misschien weer slechter.</li>
              </ul>
              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_3_2.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Adviezen voor bewegen',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_3_3-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Bewegen helpt als je een hernia hebt. Bewegen zorgt ervoor dat je spieren niet zwakker of stijf worden.</p>
              <ul>
                <li>Probeer elke dag te doen wat je normaal doet.</li>
                <li>Blijf ook werken als het kan. Bespreek met de bedrijfsarts hoe je dit kunt doen.</li>
                <li>Probeer elke dag te bewegen. Blijf doorgaan met je eigen sport. Of ga wandelen, fietsen, zwemmen, doe yoga of iets anders wat bij je past en wat lukt.</li>
                <li>Zorg wel dat je ook genoeg rust neemt. Verdeel het bewegen over de dag.</li>
              </ul>

              <p>Je kunt ook oefeningen doen. Die vind je op <a href="https://www.thuisarts.nl/overzicht/film/oefeningen-bij-lage-rugpijn" target="_blank">Thuisarts bij lage rugpijn</a>.</p>

              <p>Als bewegen pijn doet:</p>
              <ul>
                <li>Probeer niet in een houding te staan of te zitten die veel pijn doet.</li>
                <li>Maak ook geen bewegingen die veel pijn doen.</li>
                <li>Probeer elke dag een beetje meer te gaan bewegen.</li>
              </ul>
              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_3_3.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Hulp van een fysiotherapeut',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_3_4-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Misschien lukt het niet om genoeg te bewegen. Dan kun je hulp krijgen van een fysiotherapeut of oefentherapeut (cesar of mensendieck). Die maakt samen met jou een plan om te bewegen. Ook leer je oefeningen die je thuis en op je werk kunt doen.</p>

              <p>Misschien twijfel je of je bepaalde dingen wel of niet kunt doen. </br>
                De therapeut kan je daar advies over geven.</p>

              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_3_4.jpg alt="" />
            </div>
          `,
        },
      ],
      button: 'Klaar met lezen, ga verder',
    },
    {
      path: '/stap-2/voordelen-en-nadelen-van-afwachten-en-blijven-bewegen',
      routeId: 'P15-009',
      nextRouteId: 'P15-015',
      type: 'explanation',
      title: 'Wat zijn de voordelen en nadelen van afwachten en blijven bewegen?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Voordelen van afwachten en bewegen:</p>
          <ul>
            <li>Je lichaam zorgt er meestal voor dat de hernia vanzelf verdwijnt.</li>
            <li>Je gebruikt geen medicijnen, dus je hebt geen last van bijwerkingen.</li>
            <li>Je hebt niet de risico's van narcose en een operatie.</li>
            <li>Door bewegen word je fitter, sterker en soepeler.</li>
            <li>Als je ook rugpijn hebt, kan dat door veel bewegen sneller minder worden dan na een operatie.</li>
          </ul>

          <p>Nadelen van afwachten:</p>
          <ul>
            <li>Je hebt pijn en moet daarmee omgaan.</li>
            <li>Je weet niet wanneer de beenpijn weggaat.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/afwachten-en-normaal-blijven-bewegen-met-medicijnen',
      routeId: 'P15-010',
      nextRouteId: 'P15-011',
      type: 'popupCards',
      title: 'Afwachten en normaal blijven bewegen met medicijnen tegen de pijn',
      align: 'left',
      description: `
        <div>
          <p>Je kunt bij een hernia afwachten. Dat betekent dat je wacht tot de hernia vanzelf overgaat.</p>

          <p>Afwachten betekent niet: niks doen. Het is belangrijk om door te gaan met je activiteiten. Ook met je werk als het kan. Bewegen is goed bij een hernia. Ook kun je zelf dingen doen die de pijn minder erg maken.</p>

          <p>Bekijk de adviezen bij afwachten en bewegen met medicijnen:</p>
        </div>
      `,
      cards: [
        {
          cardTitle: 'Omgaan met pijn',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_3_1-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Wat je denkt, voelt en doet, heeft invloed op pijn:</p>
              <ul>
                <li>Bedenk dat de pijn niet schadelijk of gevaarlijk is. Er kan niets stukgaan in je rug. Je kunt je hernia ook niet erger maken. Dit kan je geruststellen.</li>
                <li>Zorg dat je bezig bent met andere dingen. Je denkt dan minder aan de pijn. Bijvoorbeeld door leuke dingen doen, mensen ontmoeten, werken, hobby's, muziek en natuur.</li>
                <li>Zoek steun bij bijvoorbeeld familie, vrienden en collega's. Begrip, steun en vertrouwen zorgen dat je de pijn beter aankunt.</li>
                <li>Blijf werken, als dat kan. Geven je klachten problemen op het werk? Bespreek het met je werkgever en de bedrijfsarts. Aanpassingen op het werk kunnen helpen.</li>
                <li>Blijf actief. Maak een plan voor elke dag. Kies wat belangrijk voor je is.</li>
                <li>Zorg voor ontspanning. Ga bijvoorbeeld elke dag even wandelen of doe ontspannings-oefeningen.</li>
                <li>Probeer stress minder te maken. Veel stress kan pijn erger maken.</li>
                <li>Praat erover als je je somber, bang of boos voelt door de pijn. Dat kan ook met je huisarts of praktijkondersteuner.</li>
              </ul>

              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_3_1.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Adviezen om beter te slapen',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_3_2-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Als je goed slaapt, kun je de pijn overdag beter aan. Probeer welke slaapadviezen bij jou helpen, zoals:</p>
              <ul>
                <li>Probeer zo te gaan liggen dat je zo weinig mogelijk pijn hebt. Bijvoorbeeld op je rug met een paar kussens onder je knieën. Of op je zij met gebogen knieën. Praat erover met je huisarts als je door de pijn niet kunt slapen.</li>
                <li>Slaap overdag liever niet. Soms is het wel fijn om even een pauze of rustmoment te nemen als je door de pijn slecht hebt geslapen. </br>
                  Als je wilt, kun je ook even gaan liggen. Doe dit maximaal een half uur. En voordat het 3 uur 's middags is. En doe dit niet in je bed, maar bijvoorbeeld op de bank. Als je het langer doet of later op de dag, dan slaap je 's nachts misschien weer slechter.</li>
              </ul>
              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_3_2.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Adviezen voor bewegen',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_3_3-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Bewegen helpt als je een hernia hebt. Bewegen zorgt ervoor dat je spieren niet zwakker of stijf worden.</p>
              <ul>
                <li>Probeer elke dag te doen wat je normaal doet.</li>
                <li>Blijf ook werken als het kan. Bespreek met de bedrijfsarts hoe je dit kunt doen.</li>
                <li>Probeer elke dag te bewegen. Blijf doorgaan met je eigen sport. Of ga wandelen, fietsen, zwemmen, doe yoga of iets anders wat bij je past en wat lukt.</li>
                <li>Zorg wel dat je ook genoeg rust neemt. Verdeel het bewegen over de dag.</li>
              </ul>

              <p>Je kunt ook oefeningen doen. Die vind je op <a href="https://www.thuisarts.nl/overzicht/film/oefeningen-bij-lage-rugpijn" target="_blank">Thuisarts bij lage rugpijn</a>.</p>

              <p>Als bewegen pijn doet:</p>
              <ul>
                <li>Probeer niet in een houding te staan of te zitten die veel pijn doet.</li>
                <li>Maak ook geen bewegingen die veel pijn doen.</li>
                <li>Probeer elke dag een beetje meer te gaan bewegen.</li>
              </ul>

              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_3_3.jpg alt="" />

            </div>
          `,
        },
        {
          cardTitle: 'Hulp van een fysiotherapeut',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_3_4-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Misschien lukt het niet om genoeg te bewegen. Dan kun je hulp krijgen van een fysiotherapeut of oefentherapeut (cesar of mensendieck). Die maakt samen met jou een plan om te bewegen. Ook leer je oefeningen die je thuis en op je werk kunt doen.</p>

              <p>Misschien twijfel je of je bepaalde dingen wel of niet kunt doen. </br>
                De therapeut kan je daar advies over geven.</p>

              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_3_4.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Medicijnen tegen pijn',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_4_5-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Waarschijnlijk gebruik je al medicijnen tegen pijn, misschien nog niet. Pijnstillers kunnen helpen om te kunnen blijven bewegen en zoveel mogelijk te blijven doen.</p>
              <ul>
                <li>Bij weinig pijn kan paracetamol genoeg helpen.</li>
                <li>Als dat niet genoeg helpt, kun je een ontstekingsremmer erbij slikken, zoals ibuprofen, diclofenac of naproxen.</li>
                <li>Blijft de pijn met deze pijnstillers zo erg dat je bijna niets meer kunt doen? Dan zijn er nog sterke of heel sterke pijnstillers, zoals tramadol of morfine.</li>
                <li>Hou je met de pijnstillers toch veel pijn? Dan kan een neuroloog in het ziekenhuis je doorsturen naar een pijn-polikliniek. Daar kunnen ze een prik in je rug geven. Daar zitten medicijnen tegen ontstekingen in.</li>
              </ul>

              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_4_5.jpg alt="" />
            </div>
          `,
        },
      ],
      button: 'Klaar met lezen, ga verder',
    },
    {
      path: '/stap-2/wat-zijn-de-voordelen-en-nadelen-van-medicijnen-bij-een-hernia',
      routeId: 'P15-011',
      nextRouteId: 'P15-015',
      type: 'popupCards',
      title: 'Wat zijn de voordelen en nadelen van medicijnen tegen de pijn bij een hernia?',
      align: 'left',
      description: `
        <div>
          <p>Voordelen:</p>
          <ul>
            <li>Medicijnen tegen pijn helpen je om dingen te kunnen blijven doen.</li>
            <li>Medicijnen tegen pijn helpen je om beter te kunnen bewegen.</li>
          </ul>

          <p>Nadelen:</p>
          <ul>
            <li>Medicijnen tegen de pijn werken niet altijd goed bij een hernia. Waarschijnlijk moet je meer soorten pijnstillers tegelijk slikken om minder pijn te hebben.</li>
            <li>Je moet eraan denken om de pijnstillers op vaste tijden te slikken.</li>
            <li>Door medicijnen tegen pijn geneest je hernia niet sneller.</li>
            <li>Medicijnen hebben bijwerkingen.</li>
            <li>Je kunt aan sommige medicijnen tegen pijn verslaafd worden.</li>
            <li>Door sommige medicijnen mag je (tijdelijk) niet autorijden.</li>
            <li>Voor een prik in je rug moet je naar het ziekenhuis.</li>
            <li>Door een prik in je rug kan de pijn tijdelijk erger worden.</li>
          </ul>

          <p>Bekijk de medicijnen waar je meer van wilt weten:</p>
        </div>
      `,
      cards: [
        {
          cardTitle: 'Paracetamol',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_5_1-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Paracetamol helpt goed tegen de meeste soorten pijn. Het heeft weinig bijwerkingen. Maar vaak werkt paracetamol alleen niet genoeg tegen beenpijn bij een hernia.</p>

              <p>Blijf het dan toch slikken samen met andere pijnstillers.</p>

              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_5_1.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Pijnstiller die ontstekingen remt, zoals ibuprofen en naproxen',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_5_2-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Bij paracetamol kun je ibuprofen, naproxen of diclofenac nemen. Dit zijn goede pijnstillers. Ze hebben wel meer bijwerkingen en risico’s dan paracetamol.</p>

              <p>Als je gezond bent en jonger dan 60, kun je ze meestal slikken. Ben je ouder dan 60? Of heb je problemen met je gezondheid? Of gebruik je medicijnen, bijvoorbeeld tegen hoge bloeddruk of depressie? Vraag eerst aan je huisarts of je deze pijnstillers mag slikken.</p>

              <p>Bijwerkingen en risico's:</p>
              <ul>
                <li>buikpijn, misselijk zijn en diarree</li>
                <li>bloeding in maag of darmen</li>
                <li>nierproblemen, trombose en ziektes van hart en bloedvaten</li>
              </ul>

              <p>Hoe langer je ze slikt, hoe groter de kans op bijwerkingen. Overleg met je huisarts als je ze langer dan 1 week wilt slikken.</p>
              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_5_2.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Een sterke pijnstiller: tramadol',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_5_3-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Tramadol is een sterke pijnstiller. Tramadol is een stof die lijkt op morfine. Het duurt een paar dagen voordat het goed werkt.</p>

              <p>Bijwerkingen en risico's:</p>
              <ul>
                <li>Je kunt er snel verslaafd aan worden, al na 2 weken. En van een verslaving afkomen is moeilijk. Daarom krijg je zo'n pijnstiller meestal niet langer dan 2 weken.</li>
                <li>slaperig zijn. Daarom mag je in het begin niet autorijden.</li>
                <li>misselijk zijn en overgeven</li>
                <li>niet goed kunnen poepen</li>
                <li>duizelig zijn</li>
                <li>hoofdpijn</li>
                <li>droge mond</li>
                <li>veel zweten</li>
              <ul>
              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_5_3.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Een hele sterke pijnstiller, zoals morfine',
          readingTime: '2 minuten leestijdd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_5_4-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Heel sterke pijnstillers zijn bijvoorbeeld morfine, fentanyl of oxycodon.</p>

              <p>Bijwerkingen en risico's:</p>

              <ul>
                <li>Je kunt er snel verslaafd aan worden, al na 2 weken. En van een verslaving afkomen is moeilijk. </br>
                  Daarom krijg je zo'n pijnstiller meestal niet langer dan 2 weken. Daarna stop je er weer mee. Je kunt er daarom beter niet mee beginnen als je een psychische ziekte hebt of al eerder verslaafd was aan alcohol, drugs of pijnstillers.</li>
                <li>slaperig zijn. Daarom mag je niet autorijden.</li>
                <li>misselijk zijn en overgeven</li>
                <li>duizelig zijn</li>
                <li>niet goed kunnen poepen</li>
                <li>onrustig en in de war zijn</li>
                <li>extra pijn krijgen</li>
                <li>een gelukkig gevoel. Het is dan extra opletten dat je niet verslaafd wordt aan de pijnstiller.</li>
              </ul>
              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_5_4.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Een prik in je rug met een medicijn tegen ontstekingen',
          readingTime: '3 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_5_5-card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Je kunt een prik in je rug krijgen als pijnstillers niet genoeg helpen. En als je niet geopereerd kunt of wilt worden.</p>

              <p>Je krijgt eerst een prik in je rug met verdoving. Dan de prik met medicijnen tegen ontstekingen. Dit zijn hormonen. Ze maken de zenuwen naar het been minder gevoelig.</p>

              <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Hoe goed werkt een prik?</h2>
              <p style="margin-top: 0;">Na een paar dagen kun je de gewone dingen meestal weer doen. Je kunt nog wel pijn hebben. Vooral in de eerste 4 weken na de prik is de pijn in je been een beetje minder. De pijn is dus meestal niet weg. Het is niet goed te voorspellen bij wie een prik goed of minder goed werkt.</p>

              <h2 style="font-size: 18px; line-height: 1.6;">Bijwerkingen en risico’s:</h2>

              <ul>
                <li>pijn als je de prik krijgt</li>
                <li>een blauwe plek of ontsteking op de plek van de prik</li>
                <li>even hoofdpijn na de prik</li>
                <li>vaak: bijwerkingen van de hormonen, zoals hoge bloeddruk, warmte-aanvallen, bloed uit de vagina bij vrouwen en hartkloppingen. Sommige mensen krijgen een hoge bloedsuiker, te veel vocht in het lichaam of worden dikker.</li>
                <li>soms: ergere pijn in je rug of been na de prik</li>
                <li>soms: tijdelijk minder kracht of gevoel in je been</li>
              </ul>
              <img src=${process.env.PUBLIC_URL}/img/hernia-stap-2_5_5.jpg alt="" />
            </div>
          `,
        },
      ],
      button: 'Klaar met lezen, ga verder',
    },
    {
      path: '/stap-2/operatie-bij-een-hernia',
      routeId: 'P15-012',
      nextRouteId: 'P15-013',
      type: 'explanation',
      title: 'Operatie bij een hernia',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Een hernia-operatie gebeurt meestal als je ongeveer 12 weken klachten hebt. Later kan ook.</p>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Meestal narcose</h2>
          <p style="margin-top: 0;">De operatie gebeurt onder narcose. Dat betekent dat je in slaap bent. Je krijgt een sterk slaapmiddel, een sterke pijnstiller en een middel dat je spieren slap maakt. Ook komt er een buisje in je keel. Daarmee wordt je ademhaling geregeld.</p>

          <p>Soms kun je verdoving krijgen met een ruggenprik. Daardoor heb je geen gevoel in je onderlichaam tijdens de operatie. Je bent wel wakker.</p>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Hoe gaat de operatie</h2>
          <p style="margin-top: 0;">De chirurg maakt een snee in je rug. Je rugspieren schuift de chirurg opzij. Dan haalt de chirurg bij je wervels de bobbel gel weg die op de zenuwen in de rug drukt.</p>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Na de operatie</h2>
          <p style="margin-top: 0;">De meeste mensen kunnen 1 of 2 dagen na de operatie weer naar huis. Meestal blijf je nog een paar dagen of weken pijnstillers slikken tegen de pijn na de operatie.</p>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_6.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/wat-zijn-de-voordelen-van-een-hernia-operatie',
      routeId: 'P15-013',
      nextRouteId: 'P15-014',
      type: 'explanation',
      title: 'Wat zijn de voordelen van een hernia-operatie?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <ul>
            <li>Je hebt grote kans dat de beenpijn snel weg is na de operatie.</li>
            <li>Je weet wanneer de pijn waarschijnlijk weg zal zijn.</li>
            <li>Veel mensen kunnen na ongeveer 3 weken weer werken, sommige pas na 8 weken.</li>
            <li>Je hoeft minder lang pijnstillers te slikken.</li>
          </ul>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_6_1.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/wat-zijn-de-nadelen-van-een-hernia-operatie',
      routeId: 'P15-014',
      nextRouteId: 'P15-015',
      type: 'explanation',
      title: 'Wat zijn de nadelen van een hernia-operatie?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <ul>
            <li>Narcose geeft bijwerkingen en risico's.</li>
            <li>De operatie geeft bijwerkingen en risico's.</li>
            <li>Je moet een paar keer naar het ziekenhuis voor en na de operatie.</li>
            <li>Je moet 1 of meer nachten in het ziekenhuis blijven.</li>
            <li>Je krijgt een litteken op je rug.</li>
            <li>Na de operatie heb je een paar weken nodig om beter te worden en je normale dingen weer te kunnen doen.</li>
            <li>Na de operatie heb je meestal pijnstillers nodig. Daar kun je bijwerkingen van krijgen.</li>
            <li>Rugpijn wordt meestal niet minder na een operatie.</li>
          </ul>
        </div>
      `,
      info: [
        {
          urlText: 'Bekijk bijwerkingen en risico’s van narcose',
          title: 'Bijwerkingen en risico’s van narcose',
          content: `
            <p>Bijwerkingen en risico's van narcose zijn bijvoorbeeld:</p>
            <ul>
              <li>misselijk zijn, overgeven</li>
              <li>keelpijn, hees zijn of een naar gevoel achterin de keel. Dat komt door het buisje dat tijdens de operatie in je keel zat.</li>
              <li>allergische reacties op de narcose-medicijnen</li>
              <li>moe zijn, problemen met onthouden en aandacht</li>
              <li>je tanden kunnen beschadigd worden door het buisje in je keel</li>
            </ul>
          `,
        },
        {
          urlText: 'Bekijk bijwerkingen en risico’s van een hernia-operatie',
          title: 'Bijwerkingen en risico’s van een hernia-operatie',
          content: `
            <p>Een hernia-operatie geeft deze risico's:</p>
            <ul>
              <li>Een bloeding in je rug. Dit gebeurt bij ongeveer 5 van de 100 mensen die geopereerd worden. Soms is dan een tweede operatie nodig.</li>
              <li>Minder kracht in je been. Dit gaat vaak na een paar maanden vanzelf over.</li>
              <li>Een lek in het vlies dat de zenuwen beschermt. Dit gebeurt bij ongeveer 4 van de 100 mensen die geopereerd worden. Meestal geneest het na een paar dagen vanzelf.</li>
              <li>Ontsteking van de wond. Dit gebeurt bij ongeveer 3 van de 100 mensen die geopereerd worden.</li>
              <li>Een bloedpropje in de bloedvaten van de benen (trombose). Je krijgt dan een dik en pijnlijk been. Je moet dan langere tijd bloedverdunners gebruiken.</li>
              <li>De hernia-klachten blijven. De zenuw blijft gevoelig of pijnlijk terwijl de hernia weggehaald is. Dit is zo bij ongeveer 2 van de 100 mensen die geopereerd worden.</li>
              <li>Heel erge problemen, zoals verlamming of pijn in het been die niet meer overgaat. 1 van de 1000 mensen die geopereerd worden krijgt zulke erge problemen.</li>
            </ul>
          `,
        },
      ],
      image: {
        src: `${process.env.PUBLIC_URL}/img/hernia-stap-2_6_2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/verschillen-tussen-de-3-mogelijkheden',
      routeId: 'P15-015',
      nextRouteId: 'P15-016',
      type: 'explanation',
      title: 'Verschillen tussen de 3 mogelijkheden ',
      align: 'left',
      titleAlign: 'center',
      description: `
        <p>Hieronder zie je de belangrijkste verschillen tussen de 3 mogelijkheden:</p>
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Afwachten en normaal blijven bewegen</th>
              <th>Afwachten en normaal blijven bewegen met medicijnen tegen de pijn</th>
              <th>Een hernia-operatie</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Risico narcose?</th>
              <td>Geen risico's van narcose</td>
              <td>Geen risico's van narcose</td>
              <td>Wel risico's van narcose: misselijk zijn, overgeven, keelklachten, schade aan tanden</td>
            </tr>
            <tr>
              <th>Risico operatie?</th>
              <td>Geen risico's door een hernia-operatie</td>
              <td>Geen risico's door een hernia-operatie</td>
              <td>Wel risico's door een hernia-operatie, zoals risico op een bloeding in de rug, ontsteking van de wond en verlamming</td>
            </tr>
            <tr>
              <th>Risico medicijnen?</th>
              <td>Geen risico's van pijnmedicijnen</td>
              <td>Wel risico’s en bijwerkingen van pijnmedicijnen</td>
              <td>Wel risico's en bijwerkingen van pijnmedicijnen als je die na de operatie nodig hebt.</td>
            </tr>
            <tr>
              <th>Hoeveel pijn?</th>
              <td>Je hebt pijn en moet daar mee omgaan</td>
              <td>Je hebt minder pijn</td>
              <td>Grote kans dat je beenpijn weg is na de operatie.</td>
            </tr>
            <tr>
              <th>Wanneer is de pijn weg?</th>
              <td>Je weet niet wanneer de beenpijn overgaat. </br></br>
                Na 1 jaar hebben 88 van de 100 mensen geen beenklachten meer.</td>
              <td>Je weet niet wanneer de beenpijn overgaat. </br></br>
                Na 1 jaar hebben 88 van de 100 mensen geen beenklachten meer.</td>
              <td>Je weet wanneer de pijn waarschijnlijk weg is, namelijk bijna meteen na de operatie. </br></br>
                Na 1 jaar hebben 88 van de 100 mensen geen beenklachten meer.</td>
            </tr>
          </tbody>
        </table>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3',
      routeIndex: '3',
      routeId: 'P15-016',
      nextRouteId: 'P15-017',
      type: 'chapter',
      title: 'Wat vind je belangrijk? Wat past bij jou?',
      subtitle: 'Stap 3',
      description: `<p>Je krijgt nu zinnen te zien. Bij elke zin kun je zeggen wat je ervan vindt. Zo ontdek je wat voor jou belangrijk is. En kun je de behandeling kiezen die bij je past.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/hernia-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-1',
      routeId: 'P15-017',
      nextRouteId: 'P15-018',
      subtitle: 'Stelling',
      title: 'Ik heb er vertrouwen in dat mijn lichaam het probleem zelf oplost.',
      type: 'likertScale',
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-2',
      routeId: 'P15-018',
      nextRouteId: 'P15-019',
      subtitle: 'Stelling',
      title: 'Ik ben heel bang voor een operatie of narcose.',
      type: 'likertScale',
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-3',
      routeId: 'P15-019',
      nextRouteId: 'P15-020',
      subtitle: 'Stelling',
      title: 'Ik wil geen pijnstillers waar ik verslaafd aan kan worden.',
      type: 'likertScale',
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-4',
      routeId: 'P15-020',
      nextRouteId: 'P15-021',
      subtitle: 'Stelling',
      title: 'De beenpijn is zo heftig. Ik hou dit niet lang meer vol.',
      type: 'likertScale',
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-5',
      routeId: 'P15-021',
      nextRouteId: 'P15-022',
      subtitle: 'Stelling',
      title:
        'Ik wil zo snel mogelijk weer mijn normale dingen kunnen doen. Het maakt me niet uit als daar risico’s van een operatie bij horen.',
      type: 'likertScale',
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-6',
      routeId: 'P15-022',
      nextRouteId: 'P15-023',
      title: 'Werkt een operatie beter dan afwachten?',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom:0;">Dat is niet het juiste antwoord.</h2>
            <p style="margin-top: 0;">Een operatie werkt net zo goed als afwachten. </br> Bij een operatie en bij afwachten zijn er na 1 jaar evenveel mensen die geen beenpijn meer hebben.</p>

            <p>Dus de kans dat je beenpijn na een jaar over is, is even groot: of je nu kiest voor een operatie of niet.</p>
          `,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom:0;">Dat klopt.</h2>
            <p style="margin-top: 0;">Een operatie werkt net zo goed als afwachten. Bij een operatie en bij afwachten zijn er na 1 jaar evenveel mensen die geen beenpijn meer hebben.</p>

            <p>Dus de kans dat je beenpijn na een jaar over is, is even groot: of je nu kiest voor een operatie of niet.</p>
          `,
          correctOption: true,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-7',
      routeId: 'P15-023',
      nextRouteId: 'P15-024',
      title: 'Om te zorgen dat je hernia voor altijd wegblijft, moet je je laten opereren.',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom:0;">Dat is niet het juiste antwoord.</h2>
            <p style="margin-top: 0;">Door een operatie heb je niet minder kans dat je hernia terugkomt. De kans dat je hernia ooit weer terugkomt, is net zo groot na afwachten als na een operatie. Dus er zijn evenveel mensen bij wie de hernia terugkomt: of je nu kiest voor een operatie of niet.</p>
          `,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom:0;">Dat klopt.</h2>
            <p style="margin-top: 0;">De kans dat je hernia ooit weer terugkomt, is net zo groot na afwachten als na een operatie. Dus er zijn evenveel mensen bij wie de hernia terugkomt: of je nu kiest voor een operatie of niet.</p>
          `,
          correctOption: true,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4',
      routeIndex: '4',
      routeId: 'P15-024',
      nextRouteId: 'P15-025',
      type: 'chapter',
      title: 'Wat denk je dat het beste bij jou past?',
      subtitle: 'Stap 4',
      description: `<p>Je weet nu meer over afwachten, bewegen, pijnstillers en een operatie. En wat jij belangrijk vindt.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/hernia-stap-4.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-1',
      routeId: 'P15-025',
      nextRouteId: 'P15-026',
      type: 'question',
      hideFromOverview: false,
      title: 'Wat denk je dat het beste is voor jou?',
      subtitle: 'Vraag',
      description: `
        Je kunt meerdere antwoorden kiezen.
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Afwachten, blijven bewegen',
            },
            {
              title: 'Afwachten, blijven bewegen en pijnstillers',
            },
            {
              title: 'Een operatie',
            },
          ],
        },
      ],
      showTextArea: true,
      textAreaLabel: 'Waarom wil je dat het liefst?',
      button: 'Ga verder',
    },
    {
      path: '/print-overview',
      routeId: 'P15-026',
      nextRouteId: 'end',
      type: 'end',
      header: {
        subtitle: 'Einde keuzehulp',
        title: 'Je antwoorden bij deze keuzehulp',
        description: `<p>Je bent klaar met de keuzehulp. We hopen dat je nu beter weet welke behandeling bij jou past. Bespreek dit ook met je arts.</p>`,
      },
    },
  ],
}

export default hernia
